import React from "react";
import { useLayoutContext } from "../providers/layout.provider";

export default function AboutPage() {
  const { isMobile } = useLayoutContext();

  return (
    <div className="body">
      <div className="">
        <main className="max-w-4xl mx-auto p-6 sm:p-12">
          <section className="bg-white shadow-md rounded-2xl overflow-hidden">
            <header className="px-6 py-8 sm:py-10 sm:px-10 accent text-white">
              <div className="flex gap-4">
                <div className="w-12 h-12 rounded-lg bg-white/20 flex items-center justify-center text-xl font-semibold">
                  EH
                </div>
              </div>
            </header>

            <div className="px-6 sm:px-10 -mt-6">
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 leading-tight">
                ExpenseHut
              </h1>
              <h3 className="text-gray-900 opacity-90 mt-1">
                Expense management & operations platform — founded 2024
              </h3>
            </div>

            <div className="px-6 py-8 sm:p-10">
              <article className="prose max-w-none">
                <p>
                  <strong>
                    ExpenseHut began in 2018 with a simple mission:
                  </strong>{" "}
                  empower people to take control of their expenses with clarity
                  and confidence. What started as a focused expense-management
                  app quickly grew into a powerful financial companion for
                  individuals and small teams. As adoption increased, ExpenseHut
                  evolved into a broader operations platform—bringing structure,
                  automation, and real-time insights to how businesses run.
                  Today, it's trusted across <strong>7 countries</strong>,
                  helping users manage money smarter, simplify decisions, and
                  stay in control.
                </p>

                <p>
                  <strong>
                    Over time, ExpenseHut expanded into full-scale business
                    operations with a modern POS ecosystem.
                  </strong>{" "}
                  The product connects finance, inventory, customer behavior,
                  and workforce workflows into one seamless system. With a clean
                  design, fast workflows, and AI-driven automations, ExpenseHut
                  helps restaurants, retailers, and service businesses operate
                  like larger organizations—reducing mistakes, improving
                  turnover, and boosting profitability.
                </p>

                <h3 className="mt-6">Key features</h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
                  <li className="flex items-start gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 text-teal-500 shrink-0 mt-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      Ultra-fast POS with KDS integration and AI kiosk ordering
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 text-teal-500 shrink-0 mt-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      Smart inventory: recipe-based auto-deductions and
                      liquid-first tracking
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 text-teal-500 shrink-0 mt-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      Customer rewards, CRM, and intelligent upsell
                      recommendations
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 text-teal-500 shrink-0 mt-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      Unified dashboard for expenses, operations, and analytics
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 text-teal-500 shrink-0 mt-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      Cloud-native, globally scalable platform available in 7
                      countries
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 text-teal-500 shrink-0 mt-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      AI automations that reduce manual work and improve margins
                    </span>
                  </li>
                </ul>

                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://expensehut.com/free-quote"
                    className="inline-flex items-center justify-center gap-2 rounded-lg px-5 py-3 bg-slate-900 text-white shadow hover:opacity-95"
                  >
                    Request Free Quote
                  </a>
                </div>
              </article>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}
